import Box from '@mui/material/Box';
import Popover from '@mui/material/Popover';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import React, { useState } from 'react';

type RecordItemType = {
  row: any;
  rowIndex: number;
  handleEditCanvas: (karteid: number, rowIndex: number) => void;
};

const RecordItem: React.FC<RecordItemType> = ({ row, rowIndex, handleEditCanvas }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const openPopover = Boolean(anchorEl);

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleOpenDetail = () => {
  //   setOpenDetail(!openDetail);
  // };

  // const handleChange = (event: any, value: any) => {
  //   setThumbnailSlide(row.records[0]?.items[value - 1]?.thumbnail || '');
  // };

  // const handleCloseConfirmDelete = () => {
  //   setOpenConfirm(false);
  // };

  // const handleOpenConfirmDelete = () => {
  //   setOpenConfirm(true);
  // };

  // const handleDelete = () => {
  //   setOpenConfirm(false);
  //   const token = getToken();
  //   try {
  //     postAPI(`/karte/delete-karte?token=${token}`, {
  //       id: row.karteid,
  //       patientid: patientid,
  //     }).then((res) => {
  //       if (res.code === 200) {
  //         handleDeleteKartes();
  //       }
  //     });
  //   } catch (error) {
  //     console.error('Failed to delete data:', error);
  //     return;
  //   }
  // };

  const handleEdit = (rowIndex: number) => {
    handleEditCanvas(row.karteid, rowIndex);
  };

  return (
    <>
      <TableRow
        hover
        key={row.name}
        sx={{
          '&:last-child td, &:last-child th': { border: 0 },
          '& .MuiTableCell-root.MuiTableCell-body': {
            py: '4px',
            borderBottom: '1px solid #F3F3F3',
          },
          cursor: 'pointer',
        }}
        onClick={() => handleEdit(rowIndex)}
      >
        <TableCell>
          <Box
            component='img'
            src={row.records[0]?.items[0]?.thumbnail || ''}
            alt='face-patient'
            width={'40px'}
            height={'auto'}
            sx={{ cursor: 'pointer' }}
            border={'1px solid #F3F3F3'}
            onMouseEnter={(event) => handlePopoverOpen(event)}
            onMouseLeave={handlePopoverClose}
          />
          <Popover
            id='mouse-over-popover'
            open={openPopover}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              pointerEvents: 'none',
              '& .MuiPaper-root.MuiPopover-paper': {
                boxShadow: 'none',
                height: '150px',
                overflowY: 'hidden',
              },
            }}
          >
            <Box
              component='img'
              src={row.records[0]?.items[0]?.thumbnail || ''}
              alt='face-patient'
              width={'200px'}
              height={'150px'}
              sx={{ objectFit: 'contain' }}
              border={'4px solid #F3F3F3'}
            ></Box>
          </Popover>
        </TableCell>
        <TableCell align='left'>
          {row.kartedate}
        </TableCell>
        <TableCell align='left'>{row.doctors}</TableCell>
        <TableCell align='left'>{row.kartetext}</TableCell>
      </TableRow>
    </>
  );
};

export default RecordItem;
